import style from './EmailLink.module.scss';

export interface EmailLinkProps {
    email: string;
}

interface Props extends EmailLinkProps {}

export function EmailLink({ email }: Props) {
    return (
        <a
            href={`mailto:${email}`}
            className={style.root}
        >
            {email}
        </a>
    );
}
